// treatment-selector.component.ts
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Treatment } from 'app/core/classes/treatment';
import { AUSTreatmentTypes } from 'app/core/types/aus-form-types';
import { Horse } from 'app/core/classes/horse';

@Component({
  selector: 'app-treatment-selector',
  templateUrl: './treatment-selector.component.html',
  styleUrls: []
})
export class TreatmentSelectorComponent {
  @Input() treatmentTypes: TreatmentTab[];
  @Input() treatment: Treatment;
  @Input() selectedTab: string = "";
  @Input() treatmentForm: any;
  @Input() hasNoTreatment: boolean;
  @Input() toggleRequired: boolean;
  @Input() isEdit: boolean;
  @Input() toggleLabel: string;
  @Output() setHasNoTreatment = new EventEmitter<boolean>();
  @Output() typeSelected = new EventEmitter<{ type: string, toggleLabel: string }>();
  @Input() tabs: any;
  @Input() horse: Horse;

  onTreatmentTypeClick(type: string) {
    if (!this.isEdit) {
      this.treatment.type = type || this.selectedTab;
      this.typeSelected.emit({ type: this.treatment.type, toggleLabel: this.getToggleLabel() });
    }
  }

  getToggleLabel(): string {
    if (this.treatment.type == AUSTreatmentTypes.trainer_potential_long_acting_mdf)
      return 'No long-acting medication has been administered';
    else if (this.treatment.type == AUSTreatmentTypes.trainer_routine_procedure_form)
      return 'No procedures to declare';
    else if (this.treatment.type == AUSTreatmentTypes.trainer_routine_mdf)
      return "No medications has been administered";
    else if (this.treatment.type == AUSTreatmentTypes.pre_travel_trainer_potential_long_acting)
      return 'No';
    else if (this.treatment.type == AUSTreatmentTypes.pre_travel_trainer_routine)
      return 'No medications has been administered';
    else if (this.treatment.type == AUSTreatmentTypes.pre_travel_trainer_routine_procedure_form)
      return "No procedures to declare";
    return 'No medications to declare'
  }

  shouldHideAddBtn(type: string) {
    if(this.horse)
    {
      if (this.tabs.isPreTravelTab && this.horse.is_preTravel_forms_completed) {
        return true;
      }
  
      if (this.tabs.isPreRaceTab && !this.horse.is_preTravel_forms_completed) {
        return true;
      }
  
      if((this.horse.next_to_submit != type && 
                                !this.horse.submitted_treatment_types.includes(type)) &&
                                !this.horse.submitted_notes_types.includes(type))
      {
        return true;
      }
    }

    return false;
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/custom/common/treatmentSelectorComponent.component.ts